module.exports = __webpack_public_path__ + "img/token-pocket-icon-3.4c398a97.png";